
export const CHECKOUT_URL = "https://dentistas.impultienda.ar/checkout/refinamiento";

export const PIXEL_ID = "1591693235820229";

export const IMAGES = {
  mockup: "https://cdn.magicpatterns.com/uploads/11HEsEHQ1iojnyiuteti4H/Diseno_sin_titulo-3.png",
  bono1: "https://cdn.magicpatterns.com/uploads/5SXYUXrxQxQNNiDoxVkNDR/BONO_1_REFINAMIENTO.png",
  bono2: "https://cdn.magicpatterns.com/uploads/9tdmNB8QSkCEM6xWYUU5V8/BONO_2_REFINAMIENTO.png",
  bono3: "https://cdn.magicpatterns.com/uploads/fK6bBtqWsRMbCPoMHGboSn/BONO_3_REFINAMIENTO.png",
  bono4: "https://cdn.magicpatterns.com/uploads/ezst1pkhuTFhMLCTC79Nmg/BONO_4_REFINAMIENTO.png",
  bono5: "https://cdn.magicpatterns.com/uploads/sg4RZQ1hM6s1ZyxkDwsggG/BONO_5_REFINAMIENTO.png",
};

export const AVATARS = {
  maria: "https://cdn.magicpatterns.com/patterns/generated-images/1a8202ce-bb9a-4b79-983e-dd58495f60c5.jpg",
  roberto: "https://cdn.magicpatterns.com/patterns/generated-images/0278856d-3263-4ece-b342-51596c13a75a.jpg",
  andrea: "https://cdn.magicpatterns.com/patterns/generated-images/f38a9a49-c793-47db-b0b9-7bf64df6954a.jpg",
  carolina: "https://cdn.magicpatterns.com/patterns/generated-images/be574dab-d439-4db9-8d50-3518f54c7e40.jpg",
  jorge: "https://cdn.magicpatterns.com/patterns/generated-images/27ef7c51-5f50-4cb8-8643-1877cfb15eec.jpg",
};
